import {
  UPDATE_SALON_PROVIDER,
  UPDATE_SALON_PROVIDER_FAILURE,
  UPDATE_SALON_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateSalonProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SALON_PROVIDER:
      return { ...state, loading: true };
    case UPDATE_SALON_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_SALON_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateSalonProviderReducer;
